import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RouteConfigType } from './types';

export type RoutesConfigState = Partial<RouteConfigType> &
  Record<string, unknown>;

const initialState: RoutesConfigState = {};

const routesConfigSlice = createSlice({
  name: 'routesConfig',
  initialState,
  reducers: {
    setRoutesConfig: (state, action: PayloadAction<RouteConfigType>) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { setRoutesConfig } = routesConfigSlice.actions;
export const routesConfigReducer = routesConfigSlice.reducer;

export default routesConfigSlice;
